export const OperatorUserModel = {
  id: null,
  login: "",
  password: "",
  name: "",
  email: "",
  company: null,
  phoneNumber: "",
  jobTitle: "",
  faxNumber: "",
  neverExpires: false,
  roles: [],
  agencyId: "",
  agencyName: "",
  approved: "",
  updated: "",
};

export const getAllOperatorUsers = async (
  setOperatorUsers,
  setAuthenticationChecked,
) => {
  const endpoint = "/admin/users/operator/all.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setOperatorUsers(res.data);
    });
    if (res.success === true) {
      setAuthenticationChecked("Success");
    } else if (
      res.error !== undefined &&
      res.error !== null &&
      res.error.code === "UNAUTHORIZED"
    ) {
      setAuthenticationChecked("UNAUTHORIZED");
    } else if (
      res.error !== undefined &&
      res.error !== null &&
      res.error.code === "FORBIDDEN"
    ) {
      setAuthenticationChecked("FORBIDDEN");
    }
    if (!res.ok) {
      if (res.status === 403) {
        setAuthenticationChecked("FORBIDDEN");
      }
      throw new Error(`Error ${res.status} : ${res.statusText}`);
    }
  } catch (err) {
    if (err.message.indexOf("401") > -1) {
      setAuthenticationChecked("UNAUTHORIZED");
    } else if (err.message.indexOf("403") > -1) {
      setAuthenticationChecked("FORBIDDEN");
    }
  }
};

export const getOperatorUser = async (userId, setOperatorUser) => {
  const endpoint = "/admin/users/operator/" + userId + "/user.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setOperatorUser(res.data);
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status} : ${res.statusText}`);
    }
  } catch (err) {}
};

export const createOperatorUserAcc = async (operatorUser) => {
  const endpoint = "/admin/users/operator/create.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(operatorUser),
    });
    res.json().then((res) => {
      if (res.success) alert("New Operator User Account is Created");
      else alert("Operator Creation went wrong..." + res.error.message);
    });
  } catch (err) {
    alert("Something went wrong--->" + err);
  }
};

export const updateOperatorUser = async (operatorUser) => {
  const endpoint = "/admin/users/operator/" + operatorUser.id + "/user.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(operatorUser),
    });
    res.json().then((res) => {
      if (res.success) alert("Operator User Account has been Updated");
      else alert("Operator Update went wrong-->" + res.error.message);
    });
  } catch (err) {
    alert("Something went wrong-->" + err);
  }
};

export const deleteOperatorUser = async (operatorUser) => {
  const endpoint = "/admin/users/operator/" + operatorUser.id + "/user.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "DELETE",
    });
    res.json().then((res) => {
      if (res.success) alert("Operator User Account has been Deleted");
      else alert("Operator deletion went wrong-->" + res.error.message);
    });
  } catch (err) {
    alert("Something went wrong--->" + err);
  }
};

export const getRoles = async (setRoles) => {
  const endpoint = "/admin/users/operator/roles.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setRoles(res.data);
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getAgencies = async (setAgencies) => {
  const endpoint = "/admin/users/operator/agencies.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setAgencies(res.data);
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const checkPassword = async (
  password,
  setPassStrength,
  setPwdSuggestion,
) => {
  const endpoint = "/admin/check-password.json";
  try {
    const res = await fetch(
      process.env.REACT_APP_API_HOST +
        endpoint +
        `?password=${encodeURIComponent(password)}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password }),
      },
    );
    const data = await res.json();
    if (setPassStrength) setPassStrength(data.data.strength);
    if (setPwdSuggestion)
      setPwdSuggestion(
        data.data.valid
          ? data.data.message
          : data.data.details + "; " + data.data.message,
      );
    return data.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};
